import React from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'

type LoaderProps = {
  label?: string
  minHeight?: number | string
}

const Loader: React.FC<LoaderProps> = ({ label, minHeight = 200 }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1.5,
      minHeight,
      width: '100%',
    }}
  >
    <CircularProgress size={40} thickness={4} />
    {label && (
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    )}
  </Box>
)

export default Loader
